pt({ "es": { "cmsf-branding": { "buttonLabel": "Creado en HubSpot", "dropdown": { "reportAbuse": "Informar de un abuso", "getCms": "Crear un sitio web propio gratuito" } } } });
export var translations;
function pt(t) { (translations = translations || []).push(t); }

